// frontend/src/api/proposalApi.js

import api from "./api";

// Obtener todas las propuestas
export const fetchProposals = async () => {
  try {
    const response = await api.get("/proposals/");
    return response.data;
  } catch (error) {
    console.error("Error fetching proposals:", error);
    throw error;
  }
};

// Obtener detalle de una propuesta por ID
export const fetchProposalById = async (id) => {
  try {
    const response = await api.get(`/proposals/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching proposal with ID ${id}:`, error);
    throw error;
  }
};

// Obtener resultado de la búsqueda
export const searchProposals = async (query) => {
  try {
    const response = await api.get(
      `/proposals/?search=${encodeURIComponent(query)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error searching proposals:", error);
    throw error;
  }
};

// Exportar propuestas por ID
export const exportProposalsById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/proposals/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting proposals by ID:", error);
    throw error;
  }
};

export const filterProposals = async (filters) => {
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, v]) => v !== "" && v !== null && v !== undefined,
      ),
    );

    const query = new URLSearchParams(cleanParams).toString();

    const response = await api.get(`/proposals/?${query}`);

    // Forzamos a devolver siempre un objeto con clave `results`
    return response.data;
  } catch (error) {
    console.error("Error filtering proposals:", error);
    throw error;
  }
};

export const deleteProposals = async (idsArray) => {
  if (!idsArray?.length) return [];

  return Promise.allSettled(
    idsArray.map((id) => api.delete(`/proposals/${id}/`)),
  );
};
